/* no babel so we have to use old js syntax */
window.Popper = require('popper.js');
require('bootstrap');

window.List = require('list.js');
let Swal = require('sweetalert2/src/sweetalert2');
Swal = Swal.default;

import "@fontsource/hind-siliguri/latin.css";
import "@fontsource/open-sans-condensed/latin.css";
import "@fontsource/open-sans/latin.css";

//window.blueimp = require('blueimp-gallery');
window.slick = require('slick-carousel');



;$(function() {

  $('.slick').slick();

  var $hamburger = $(".hamburger");
    $hamburger.on("click", function(e) {
        $hamburger.toggleClass("is-active");
        // Do something else, like open/close menu
    });

  window.addEventListener('listInit', function (e) {

    // enable filter
    function addFilter(key) {
      $('.filter-'+ key).on('click',function(e) {

        var $q = $(this).attr('data-filter');

        let filterBox = (e.target.classList.contains('filter'))
          ? e.target
          : e.target.parentNode;

        if(filterBox.classList.contains('active')) {
          listObj.filter();
          filterBox.classList.remove('active');

        } else {

          $('.filter-'+ key).removeClass('active');
          listObj.filter(function(item) {
            return (item.values()[key] == $q);
          });
          filterBox.classList.add('active');
        }

      });
    }
    listFilter.forEach(element => addFilter(element));

    /**
     *
     * @param target
     * @param config
     */
    function observePagination(target,config)
    {
      target = target||document.querySelector('.pagination');
      config = config||{childList:true, subtree:true};

      window.paginationObserver = new MutationObserver(function(mut, observer){
        window.paginationObserver.disconnect();
        upgradePagination(
          window.listObj,
          document.querySelectorAll('.pagination > .page-item')
        );
        window.paginationObserver.observe(target, config);
      });

      window.paginationObserver.observe(target, config);

    }

    /**
     * add prev and next for pagination
     */
    function upgradePagination(listObj, listPagination)
    {
      for(let i=0;i<listPagination.length;i++) {
        let elem = listPagination[i];
        if(elem.classList.contains('disabled') && i == 0) {
          elem.querySelector('.page-link').innerHTML = '<';
          elem.querySelector('.page-link').parentNode.classList.remove('disabled');
          elem.addEventListener('click', function () {
            listObj.show(listObj.i - 10, listObj.page);
          });
        }
        if(elem.classList.contains('disabled') && i == listPagination.length-1) {
          elem.querySelector('.page-link').innerHTML = '>';
          elem.querySelector('.page-link').parentNode.classList.remove('disabled');

          elem.addEventListener('click', function () {
            listObj.show(listObj.i + 10, listObj.page);
          });
        }
      }
    }

    function elemHide(elem) {
      elem.classList.add('d-none');
    }

    function elemShow(elem) {
      elem.classList.remove('d-none');
    }

    const simplecart_button_add_selector = '[data-simplecart_action_add]';
    const simplecart_button_remove_selector = '[data-simplecart_action_remove]';
    const simplecart_button_update_selector = '[data-simplecart_action_update]';
    const simplecart_list_item_button_wrapper_selector = '[data-simplecart_list_item_button_wrapper]';
    const simplecart_list_item_wrapper_selector = '[data-simplecart_list_item_wrapper]';
    const simplecart_basket_list_wrapper_selector = '[data-simplecart_basket_list]';
    const simplecart_basket_list_item_button_wrapper_selector = '[data-simplecart_basket_list_item_button_wrapper]';
    const simplecart_qty_selector = '[data-simplecart_qty]';
    const simplecart_title_selector = '[data-simplecart_title]';
    const simplecart_id_selector = '[data-simplecart_id]';
    const simplecart_vpe_selector = '[data-simplecart_vpe]';
    const simplecart_order_btn_selector = '[data-simplecart_order_btn]';
    const simplecart_order_form_wrapper_selector = '[data-simplecart_order_form_wrapper]'

    /**
     *
     * @param e
     */
    function addToCart(e) {
      e.preventDefault()

      let addBtn = e.target;

      let  title = addBtn.getAttribute(simplecart_title_selector.replace(/\[|\]/g,'')),
        id = addBtn.getAttribute(simplecart_id_selector.replace(/\[|\]/g,'')),
        vpe = addBtn.getAttribute(simplecart_vpe_selector.replace(/\[|\]/g,'')),
        qty = addBtn.hasAttribute(simplecart_qty_selector.replace(/\[|\]/g,''))
          ? addBtn.getAttribute(simplecart_qty_selector.replace(/\[|\]/g,''))
          : addBtn.querySelector(simplecart_qty_selector).value;

      simplecart
        .add(id, qty) //, {'title': title, 'vpe': vpe}
        .then(
          Swal.fire({
            position: 'top-end',
            title: qty +' '+ translateVPE(vpe,1) +' '+ title +' hinzugefügt!' ,
            icon: "success",
            showConfirmButton: false,
            timer: 1000
          })
        );
    }

    /**
     *
     * @param e
     */
    function removeFromCart(e) {

      e.preventDefault()

      let removeBtn = e.target;
      simplecart
        .remove(removeBtn.getAttribute(simplecart_id_selector.replace(/\[|\]/g,'')))
        .then(
          Swal.fire({
            position: 'top-end',
            title: removeBtn.getAttribute(simplecart_title_selector.replace(/\[|\]/g,'')) +' entfernt!' ,
            icon: "info",
            showConfirmButton: false,
            timer: 1000
          })
        );
    }

    function updateInCart(e) {
      e.preventDefault()

      let updateBtn = e.target;

      let  title = updateBtn.getAttribute(simplecart_title_selector.replace(/\[|\]/g,'')),
        id = updateBtn.getAttribute(simplecart_id_selector.replace(/\[|\]/g,'')),
        vpe = updateBtn.getAttribute(simplecart_vpe_selector.replace(/\[|\]/g,'')),
        qty = updateBtn.hasAttribute(simplecart_qty_selector.replace(/\[|\]/g,''))
          ? updateBtn.getAttribute(simplecart_qty_selector.replace(/\[|\]/g,''))
          : updateBtn.querySelector(simplecart_qty_selector).value;


      Swal.fire({

        icon: 'question',
        input: 'number',
        inputLabel: 'Wieviele '+ translateVPE(vpe,2) +' '+ title +' brauchst Du?',
        inputValue: qty,
        inputAttributes: {
          min: 0,
          max: 99
        },
        confirmButtonColor: "#009ee3",
        confirmButtonText: "in den Warenkorb",
        showDenyButton: false,
        denyButtonText: 'entfernen',
        denyButtonAriaLabel: 'Thumbs down',
        denyButtonColor: "#e2000b",
        reverseButtons: true,
        showLoaderOnConfirm: true,
        preConfirm: (new_qty) => {
          return simplecart.update(id, new_qty)
        },
        preDeny: (new_qty) => {
          return simplecart.remove(id)
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.isConfirmed) {

          if(result.value == 0) {
            Swal.fire({
              position: 'top-end',
              title: title +' entfernt!' ,
              icon: "info",
              showConfirmButton: false,
              timer: 1000
            })
          } else {
            Swal.fire({
              position: 'top-end',
              title: (result.value) +' '+ translateVPE(vpe,(result.value)) +' '+ title +' im Warenkorb!' ,
              icon: "success",
              showConfirmButton: false,
              timer: 1000
            })
          }
        }
      })

    }

    /**
     *
     * @param wrapper
     * @param cartData
     */
    function simpleCartButtonsInit(wrapper, cartData)
    {

      let addBtn = wrapper.querySelector(simplecart_button_add_selector);
      if(addBtn) {
        addBtn.addEventListener('click' , addToCart);
        if(cartData) {
          simpleCartButtonDecorate(addBtn, cartData);
        }
      }

      let removeBtn = wrapper.querySelector(simplecart_button_remove_selector);
      if(removeBtn) {
        removeBtn.addEventListener('click' , removeFromCart);
        if(cartData) {
          simpleCartButtonDecorate(removeBtn, cartData);
        }

      }

      let updateBtn = wrapper.querySelector(simplecart_button_update_selector);
      if(updateBtn) {

        updateBtn
          .addEventListener('click', updateInCart);

        if(cartData) {
          simpleCartButtonDecorate(updateBtn, cartData);
        }

      }
    }

    /**
     *
     * @param btnElem
     * @param cartData
     */
    function simpleCartButtonDecorate(btnElem, cartData) {

      if (btnElem.hasAttribute(simplecart_button_remove_selector.replace(/\[|\]/g,''))) {
        if(cartData[btnElem.getAttribute(simplecart_id_selector.replace(/\[|\]/g,''))]) {
          elemShow(btnElem);

        } else {
          elemHide(btnElem);
        }
      }

      if (btnElem.hasAttribute(simplecart_button_add_selector.replace(/\[|\]/g,''))) {

        if(cartData[btnElem.getAttribute(simplecart_id_selector.replace(/\[|\]/g,''))]) {
          let icon = btnElem.querySelector('.flaticon-supermarket');
          //icon.classList.add('bg-primary');
          //icon.classList.remove('bg-secondary');
          //elemHide(btnElem.querySelector('.text'));

        } else {
          let icon = btnElem.querySelector('.flaticon-supermarket');
          //icon.classList.remove('bg-primary');
          //icon.classList.add('bg-secondary');
          //elemShow(btnElem.querySelector('.text'));
        }

      }

    }

    /**
     * init
     */
    function init() {
      let inCart = simplecart
        .list()
        .then(cartData => {
          document.querySelectorAll(simplecart_list_item_button_wrapper_selector).forEach(wrapper => {
            simpleCartButtonsInit(wrapper, cartData)
          });
          buildBasket(cartData);
          buildOrderBtn();
        });

      upgradePagination(
        e.detail.listObj,
        document.querySelectorAll('.pagination > .page-item')
      );
      observePagination();
    }

    /**
     *
     * @param cartData
     */
    function buildBasket(cartData) {
      document.querySelector('[data-simplecart_basket_list]').innerHTML = '';

      const requestData = {
        filter_key: 'sku',
        filter_values: Object.keys(cartData)
      }

      fetch('/task:datafilter.products.filter', {
        cache: 'no-cache',
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(requestData)
      })
        .then(response => response.json())
        .then(productData => {

          Object.entries(cartData).forEach(([key, value]) => {

            let basketNode = document.querySelector('[data-simplecart_basket_list]'),
              templateNode = document.querySelector('[data-simplecart_basket_list_item_template]');

            const mappingView = {
              'data-simplecart_product_sku': 'sku',
              'data-simplecart_product_title': 'title',
              'data-simplecart_product_category': 'category',
              'data-simplecart_product_quantity': 'quantity',
              'data-simplecart_product_size': 'size',
              'data-simplecart_product_vpe': 'vpe'
            }

            Object.entries(mappingView).forEach(([simpleCartKey, productKey]) => {
              templateNode.content.querySelectorAll('['+ simpleCartKey +']').forEach(node => {
                if(productKey == 'vpe') {
                  node.textContent = translateVPE(productData[key][productKey], value[0]['quantity'])
                } else {
                  node.textContent = productData[key][productKey];
                }
              })
            });

            const mappingData = {
              [simplecart_id_selector]: 'sku',
              [simplecart_title_selector]: 'title',
              [simplecart_vpe_selector]: 'vpe',
            }

            Object.entries(mappingData).forEach(([simpleCartKey, productKey]) => {
              templateNode.content.querySelectorAll(simpleCartKey).forEach(node => {
                node.setAttribute(
                  simpleCartKey.replace(/\[|\]/g,''),
                  productData[key][productKey]
                )
              })
            });

            templateNode.content.querySelectorAll('[data-simplecart_qty]').forEach(node => {
              node.value = value[0]['quantity']
            })

            let clone = document.importNode(templateNode.content, true);

            basketNode.appendChild(clone);

          })

          document.querySelectorAll(simplecart_basket_list_item_button_wrapper_selector).forEach(wrapper => {
            simpleCartButtonsInit(wrapper, cartData)
          });

          if(Object.entries(cartData).length > 0) {
          } else {
            document.querySelector('[data-simplecart_basket_list_empty]').classList.remove('d-none');
          }


          if(Object.entries(cartData).length > 0) {

            document.querySelector('[data-simplecart_basket_list_empty]').classList.add('d-none');

            // show button to request delivery on basket-change
            document.querySelectorAll(simplecart_order_btn_selector).forEach(orderBtn => {
              if(orderBtn.classList.contains('d-none')) {
                orderBtn.classList.remove('d-none');
              }
            });

            // hide form to request delivery on basket-change
            document.querySelectorAll(simplecart_order_form_wrapper_selector).forEach(orderFormWrapper => {
              if(!orderFormWrapper.classList.contains('d-none')) {
                orderFormWrapper.classList.add('d-none');
              }
            });

          } else {
            const emptyCartNotice = document.querySelector('[data-simplecart_basket_list_empty]');
            if(!emptyCartNotice.classList.contains('d-none')) {
              emptyCartNotice.classList.remove('d-none');
            }

            // show button to request delivery on basket-change
            document.querySelectorAll(simplecart_order_btn_selector).forEach(orderBtn => {
              if(!orderBtn.classList.contains('d-none')) {
                orderBtn.classList.add('d-none');
              }
            });

            // hide form to request delivery on basket-change
            document.querySelectorAll(simplecart_order_form_wrapper_selector).forEach(orderFormWrapper => {
              if(!orderFormWrapper.classList.contains('d-none')) {
                orderFormWrapper.classList.add('d-none');
              }
            });
          }

        })
    }

    function buildOrderBtn() {
      document.querySelectorAll(simplecart_order_btn_selector).forEach(orderBtn => {
        orderBtn.addEventListener('click' , showOrderForm);
      });
    }

    function showOrderForm(e) {
      e.preventDefault()
      e.target.classList.add('d-none');
      const orderFormWrapper = document.querySelector(simplecart_order_form_wrapper_selector);
      orderFormWrapper.classList.remove('d-none');
      orderFormWrapper.scrollIntoView({block: "start", behavior: "smooth"});
    }

    /**
     *
     * @param text
     * @param qty
     * @returns {string}
     */
    function translateVPE(text, qty)
    {
      if(text == 'KA' && qty == 1) {
        return 'Kasten';
      }
      if(text == 'KA' && qty > 1) {
        return 'Kästen';
      }
      if(text == 'CON') {
        return 'Container';
      }
    }

    /**
     * refresh list after cart-action
     */
    function refresh() {
      let inCart = simplecart
        .list()
        .then(cartData => {
          refreshList(document.querySelectorAll('[data-simplecart_list_item_button_wrapper]'),cartData)
          buildBasket(cartData);
        });
    }

    /**
     *
     * @param elems
     * @param cartData
     */
    function refreshList(elems, cartData) {
      elems.forEach(wrapper => {
        simpleCartButtonDecorate(wrapper.querySelector(simplecart_button_add_selector), cartData)
        simpleCartButtonDecorate(wrapper.querySelector(simplecart_button_remove_selector), cartData)
      });
    }

    /**
     *
     * @param e
     */
    function listUpdate(e)
    {

      let inCart = simplecart
        .list()
        .then(cartData => {
          document.querySelectorAll(simplecart_list_item_button_wrapper_selector).forEach(wrapper => {
            simpleCartButtonsInit(wrapper, cartData)
          });
        });

    }

    init();

    window.addEventListener('simplecart_add', refresh)
    window.addEventListener('simplecart_remove', refresh)
    window.addEventListener('simplecart_destroy', refresh)
    window.addEventListener('simplecart_clear', refresh)
    window.addEventListener('simplecart_update', refresh)
    window.addEventListener('listUpdate', listUpdate)




    /*
    document.querySelectorAll('[data-simplecart_action]').forEach(addButton =>
      addButton.addEventListener('click', function(e) {

        e.preventDefault()

        let type = e.target.getAttribute('data-simplecart_action');
        let test = e.target.getAttribute('data-simplecart_target');

        if(type == 'clear') {
          return simplecart.clear();
        }

        if(type == 'destroy') {
          return simplecart.destroy();
        }

        let targetObj = document.getElementById(e.target.getAttribute('data-simplecart_target'));
        let qty = targetObj.querySelector('[data-simplecart_qty]').value;
        let title = targetObj.querySelector('[data-simplecart_title]').value;
        let id = targetObj.querySelector('[data-simplecart_id]').value;

        if(type == 'add') {
          simplecart.add(id, qty, {'title': title})
        }

        if(type == 'update') {
          simplecart.remove(id);
          simplecart.add(id, qty, {'title': title})
        }

        if(type == 'remove') {
          simplecart.remove(id)
        }

      })

    );


    function refreshList() {

      // reset
      let list = document.querySelector('[data-simplecart_list_item_wrapper]');
      list.querySelectorAll('[data-simplecart_action="add"]').forEach(elem => elemShow(elem));
      list.querySelectorAll('[data-simplecart_action="remove"]').forEach(elem => elemHide(elem));

      simplecart.list().then(
        cartData => {
          for (var key in cartData) {
            let row = document.getElementById(key);
            if(row) {
              row.querySelector('[data-simplecart_qty]').value = cartData[key][0]['quantity']
              row.querySelector('[data-simplecart_action="add"]')

              elemHide(row.querySelector('[data-simplecart_action="add"]'));
              elemShow(row.querySelector('[data-simplecart_action="remove"]'));

            }
          }
        });
    }

    function refreshBasket() {

      // empty basket

      document.querySelector('[data-simplecart_basket_list]').innerHTML = '';

      // get new one
      simplecart.list().then(
        cartData => {

          const requestData = {
            filter_key: 'sku',
            filter_values: Object.keys(cartData)
          }

          fetch('/task:datafilter.products.filter', {
              cache: 'no-cache',
              method: 'POST',
              headers: {'Content-Type': 'application/json'},
              body: JSON.stringify(requestData)
          })
            .then(response => response.json())
            .then(productData => {

              Object.entries(cartData).forEach(([key, value]) => {

                let basketNode = document.querySelector('[data-simplecart_basket_list]'),
                  templateNode = document.querySelector('[data-simplecart_basket_list_item_template]');

                const mapping = {
                  'data-simplecart_product_sku': 'sku',
                  'data-simplecart_product_title': 'title',
                  'data-simplecart_product_category': 'category',
                  'data-simplecart_product_quantity': 'quantity',
                  'data-simplecart_product_size': 'size',
                  'data-simplecart_product_vpe': 'vpe'
                }

                Object.entries(mapping).forEach(([simpleCartKey, productKey]) => {
                  templateNode.content.querySelectorAll('['+ simpleCartKey +']').forEach(node => {
                    node.textContent = productData[key][productKey];
                  })
                });

                templateNode.content.querySelectorAll('[data-simplecart_ref]').forEach(node => {
                  node.id = value[0]['id'];
                })

                templateNode.content.querySelectorAll('[data-simplecart_id]').forEach(node => {
                  node.value = value[0]['id'];
                })

                templateNode.content.querySelectorAll('[data-simplecart_title]').forEach(node => {
                  node.value = productData[key]['title'];
                })

                templateNode.content.querySelectorAll('[data-simplecart_qty]').forEach(node => {
                  node.value = value[0]['quantity'];
                })

                let clone = document.importNode(templateNode.content, true);

                basketNode.appendChild(clone);

              })

            })
        });
    }

    refreshList();
    refreshBasket();

    window.addEventListener('simplecart_add', function() {
      refreshBasket();
      refreshList();
    })

    window.addEventListener('simplecart_destroy', function() {
      refreshBasket();
      refreshList();
    })

    window.addEventListener('simplecart_clear', function() {
      refreshBasket();
      refreshList();
    })

    window.addEventListener('simplecart_update', function() {
      refreshBasket();
      refreshList();
    })

    window.addEventListener('simplecart_remove', function() {
      refreshBasket();
      refreshList();
    })
    */

  }, false);

//    $(".label-header").click(function() {  //use a class, since your ID gets mangled
  //    $(this).addClass("active");      //add the class to the clicked element
    //});

  /*  $(".label-header").click(function() {
        $(this).toggleClass("classA").toggleClass("classB");
        $('.togToo').toggleClass("classC").toggleClass("classD");
    })*/

  /*
    $(".auswahl-header").click(function() {
        $(this).toggleClass("active");
    })
  */

  /* ajax-form-submission
  var form = $('#contact');
  if(typeof form != 'undefined') {
    $(form).on('submit', function(e) {
      e.preventDefault();
      $('#form-response').html('');
      $(".loader").css('opacity', '1');
      $(form).find(':submit').attr('disabled', 'disabled');

      // submit the form via Ajax
      $.ajax({
        url: form.attr('action'),
        type: form.attr('method'),
        data: form.serialize(),
        success: function(result) {
          if ($(result).text().indexOf("Dank") != -1)
          {
            $('#form-response').html(result);
            $(".loader").css('opacity', '0');
            $(form).fadeOut().remove();
          } else {
            $('#form-response').html(result);
            $(form).find(':submit').removeAttr('disabled');
            $(".loader").css('opacity', '0');
          }
        }
      });
    });
  }
  */

});



// WEBPACK FOOTER //
// ./js/theme.js